<template>
  <div
    v-if="results && results.scores && !results.scores.isEmptyResults"
    id="metricsRow1"
    class="row"
    aria-hidden="true"
  >
    <div class="col-sm-7">
      <div
        id="scoreRow"
        class="row"
      >
        <div class="col-xs-4 text-center">
          <span class="evaluate-label dial-charts">
            Strength of Opening
          </span>
          <div class="chart-wrapper chart-wrapper-250">
            <div id="strengthOpeningContainer">
              <dial-chart
                tooltip-id="strengthOpeningContainer"
                :recording="recording"
                :wavesurfer="wavesurfer"
                metric="strengthOfOpening"
                :speaker-num="speakerNum"
              />
            </div>
          </div>
        </div>
        <div class="col-xs-4 text-center">
          <span class="evaluate-label dial-charts">
            Pace
          </span>
          <div class="chart-wrapper chart-wrapper-250">
            <div id="paceContainer">
              <gauge-chart
                tooltip-id="paceContainer"
                :recording="recording"
                :wavesurfer="wavesurfer"
                metric="pace"
                :speaker-num="speakerNum"
              />
            </div>
          </div>
        </div>
        <div class="col-xs-4 text-center">
          <span class="evaluate-label dial-charts">
            Clarity
          </span>
          <div class="chart-wrapper chart-wrapper-250">
            <div id="clarityContainer">
              <dial-chart
                tooltip-id="clarityContainer"
                :recording="recording"
                :wavesurfer="wavesurfer"
                metric="clarity"
                :speaker-num="speakerNum"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        id="dialRow"
        class="row"
      >
        <div class="col-xs-4 text-center">
          <span class="evaluate-label">
            Talking versus Listening
          </span>
          <small>
            (Percent spent talking)
          </small>
          <div class="chart-wrapper chart-wrapper-250">
            <div id="talkVsListenContainer">
              <simple-score
                tooltip-id="talkVsListenContainer"
                :recording="recording"
                :wavesurfer="wavesurfer"
                metric="talkVsListen"
                :speaker-num="speakerNum"
              />
            </div>
          </div>
        </div>
        <div class="col-xs-4 text-center">
          <span class="evaluate-label">
            Meaningful Conversation Switches
          </span>
          <div class="chart-wrapper chart-wrapper-250">
            <div id="convoSwitchesContainer">
              <simple-score
                tooltip-id="convoSwitchesContainer"
                :recording="recording"
                :wavesurfer="wavesurfer"
                metric="convoSwitches"
                :speaker-num="speakerNum"
              />
            </div>
          </div>
        </div>
        <div class="col-xs-4 text-center">
          <span class="evaluate-label">
            Number of Questions
          </span>
          <div class="chart-wrapper chart-wrapper-250">
            <div id="questionsContainer">
              <simple-score
                tooltip-id="questionsContainer"
                :recording="recording"
                :wavesurfer="wavesurfer"
                metric="questions"
                :speaker-num="speakerNum"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-5 text-center">
      <div class="chart-wrapper chart-wrapper-400">
        <div id="wordChartContainer">
          <recording-wordspotting
            tooltip-id="wordChartContainer"
            :recording="recording"
            :wavesurfer="wavesurfer"
            :speaker-num="speakerNum"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChartHelper from '../utils/ChartHelper';
import DialChart from '../forms/DialChart';
import RecordingWordspotting from './RecordingWordspotting';
import SimpleScore from '../forms/SimpleScore';
import GaugeChart from '../forms/GaugeChart';

export default {
  components: {GaugeChart, SimpleScore, RecordingWordspotting, DialChart},
  mixins: [ChartHelper],
  props: ['recording', 'wavesurfer', 'speakerNum'],
};

</script>